var $878c21059a487c51$exports = {};
$878c21059a487c51$exports = {
    "loading": `U\u{10D}itavam...`,
    "loadingMore": `U\u{10D}itavam jo\u{161}...`
};


export {$878c21059a487c51$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
